import React from 'react';

import SettingsPresenter from '../../../../presenters/store/invoice/SettingsPresenter';
import Group from '../../../../components/Group';
import Row from '../../../../components/Row';
import Value from '../../../../components/Value';

const InvoiceSettings = (props) => {
  const { settings, onModalOpen } = props;
  return (
    <div>
      <h3>Settings</h3>
      <Group title="Invoice Settings">
        <div className="form-header">
          <div className="form-header-single-action">
            <div
              id="invoice"
              className="button -add-button"
              onClick={onModalOpen}
            >
              Edit
            </div>
          </div>
        </div>
        <Row>
          <Value attr="contactPerson" title="Contact Person">
            {SettingsPresenter.contactPerson(settings)}
          </Value>
        </Row>
        <Row>
          <Value attr="contactEmail" title="Email">
            {SettingsPresenter.contactEmail(settings)}
          </Value>
        </Row>
        <Row>
          <Value attr="contactPhoneNumber" title="Phone Number">
            {SettingsPresenter.contactPhoneNumber(settings)}
          </Value>
        </Row>
        <Row>
          <Value attr="wiringInstructions" title="Wiring Instructions">
            {SettingsPresenter.wiringInstructionsReadable(settings)}
          </Value>
        </Row>
      </Group>
    </div>
  );
};

export default InvoiceSettings;
